<template>
    <div class="flex justify-center items-center mx-auto">
        <div class="grid grid-cols-6 gap-6">
            <table class="custom-width-table bg-white border border-gray-300">
                <thead>
                    <tr class="text-sm font-semibold text-center border-b-2 border-blue-500 uppercase">
                    <th class="px-4 py-3">Tipo CAP</th>
                    <th class="px-4 py-3">Número</th>
                    <th class="px-4 py-3">Valor</th>
                    <th class="px-4 py-3">Fecha Expedición</th>
                    <th class="px-4 py-3">Acto Administrativo</th>
                    <th class="px-4 py-3">Fecha Expedición Acto</th>
                    <th class="px-4 py-3">Acciones</th>
                    </tr>
                </thead>
                <tbody class="py-10 bg-gray-100 text-center hover:bg-gray-200 font-medium">
                    <tr v-for="(cap, index) in collectionData" :key="index">
                      <td class="px-4 py-4">{{ cap.tipoCap.nombre }}</td>
                      <td class="px-4 py-4">{{ cap.numero }}</td>
                      <td class="px-4 py-4">{{  vueNumberFormat(cap.valor_cap,{})}}</td>
                      <td class="px-4 py-4">{{ cap.fecha_expedicion }}</td>
                      <td class="px-4 py-4">{{ cap.tipo_acto_administrativo === 'ordenanza' ? 'Ordenanza' : cap.tipo_acto_administrativo === 'decreto' ? 'Decreto' : 'N/A' }}</td>
                      <td class="px-4 py-4">{{ cap.fecha_expedicion_acto || 'N/A' }}</td>
                      <td class="px-4 py-4">
                        <button v-if="cap.estado == '1'" 
                        @click="customUpdateActions?.map(async action => await action());$emit('updateValues', {'view': 'editar_cap'});$emit('updateDataCap', cap)"
                          class="items-center px-4 py-2 text-white bg-yellow-600 mt-3 sm:mt-0 sm:w-auto rounded-md hover:bg-yellow-600 focus:outline-none" title="Editar CAP">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="3" stroke="currentColor" class="inline-block w-6 h-6">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"></path>
                          </svg>
                        </button>
                        <span class="mx-2"></span>
                        <button v-if="cap.estado == '1'"  
                          @click="fetchSoporteCap(cap.id)"
                          class="items-center px-4 py-2 text-white bg-blue-600 w-full mt-3 sm:mt-0 sm:w-auto rounded-md hover:bg-blue-600 focus:outline-none" title="Visualizar CAP">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="3"
                              stroke="currentColor" class="inline-block w-6 h-6">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                  d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3"/>
                          </svg>
                        </button>
                        <span class="mx-2"></span>
                        <button v-if="cap.estado == '1'" 
                        @click="customUpdateActions?.map(async action => await action());$emit('updateValues', {'view': 'cargar_soportes_caps'});$emit('updateDataCap', cap)"
                          class="items-center px-4 py-2 text-white bg-orange-600 w-full mt-3 sm:mt-0 sm:w-auto rounded-md hover:bg-red-600 focus:outline-none" title="Cargar Soportes">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="3" stroke="currentColor" class="inline-block w-6 h-6">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 5a3 3 0 013-3h10a3 3 0 013 3v14a3 3 0 01-3 3H7a3 3 0 01-3-3V5z"></path>
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 19V9"></path>
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 14h10"></path>
                          </svg>
                        </button>
                        <span class="mx-2"></span>
                        <button  v-if="cap.estado == '1'" 
                        @click="consultarSoportesAsociados(cap.id)"
                          class="items-center px-4 py-2 text-white bg-green-500 w-full mt-3 sm:mt-0 sm:w-auto rounded-md hover:bg-green-600 focus:outline-none"
                          title="Ver Soportes CAP">
                          👁 
                        </button>
                        <span class="mx-2"></span>
                        <button  v-if="cap.estado == '1'"
                        @click="cambiarEstado(cap.id)"
                          class="items-center px-4 py-2 text-white bg-red-600 mt-3 sm:mt-0 sm:w-auto rounded-md hover:bg-red-600 focus:outline-none">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="3" stroke="currentColor" class="inline-block w-6 h-6">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
                          </svg>
                        </button>
                        <button v-if="cap.estado == '0'"
                        @click="cambiarEstado(cap.id)"
                          class="items-center px-4 py-2 text-white bg-green-600 mt-3 sm:mt-0 sm:w-auto rounded-md hover:bg-green-600 focus:outline-none">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="3" stroke="currentColor" class="inline-block w-6 h-6">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4.5 12.75l6 6 9-13.5"></path>
                          </svg>
                        </button>
                      </td>
                    </tr>
                </tbody>
            </table>
            <div v-if="showSoportesTable" class="col-span-6">
              <h1 style="font-weight: 700; font-size: 1.25rem; line-height: 1.75rem; margin-bottom: 1rem;">Soportes Asociados</h1>
              <table class="custom-width-table-soportes bg-white border border-gray-300">
                <thead>
                  <tr class="text-sm font-semibold text-center border-b-2 border-blue-500 uppercase">
                    <th class="px-4 py-3">Soporte</th>
                    <th class="px-4 py-3">Acciones</th>
                  </tr>
                </thead>
                <tbody class="py-10 bg-gray-100 text-center hover:bg-gray-200 font-medium">
                  <tr v-for="(soporte, index) in collectionDataSoportes" :key="index">
                    <td class="px-4 py-4"> SOPORTE {{ index + 1 }}</td>
                    <td  class="px-4 py-4">
                      <button @click="descargarSoporteCap(soporte.url_archivo)"
                      class="items-center px-4 py-2 text-white bg-yellow-600 w-full mt-3 sm:mt-0 sm:w-auto rounded-md hover:bg-yellow-600 focus:outline-none" title="Descargar Soporte CAP">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="3"
                              stroke="currentColor" class="inline-block w-6 h-6">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                  d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3"/>
                          </svg>
                          <span class="ml-2">Soporte Asociado CAP</span>
                      </button>
                      <span class="mx-2"></span>
                      <button  v-if="soporte.estado == '1'"
                        @click="confirmarCambioEstado(soporte.id)"
                          class="items-center px-4 py-2 text-white bg-red-600 mt-3 sm:mt-0 sm:w-auto rounded-md hover:bg-red-600 focus:outline-none">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="3" stroke="currentColor" class="inline-block w-6 h-6">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
                          </svg>
                        </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-span-6 flex justify-center">
              <button @click="handleBack" class="px-4 py-2 text-white bg-green-500 ml-3 rounded-md hover:bg-green-600 focus:outline-none">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="inline-block w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M11 19l-7-7 7-7"></path>
                </svg>
                <span class="ml-3">Volver</span>
              </button>
            </div>
        </div>
    </div>
  </template>
  
<script>
import { ref } from "vue";
// import mime from "mime";
import {useAPIRest, swal} from "@/common/constants";
import {saveUpdateData } from "@/layouts/main";
import { useAuth } from "@/components/auth/store/composables";

  export default {
    name: 'VisualizacionCAPComponent',
    props: ['view', 'paginate', 'selectedData', 'data', 'authToken','loadData', 
    'entity', 'customUpdateLoadData', 'customUpdateValueData', 'customCreateActions'],
    emits: ["updateValues", "customSaveData", 'updateDataCap'],
    data() {
      return {
        showSoportesTable: false,
        collectionDataSoportes: [],
      };
    },
    setup(props) {
      const authStored = useAuth();
      const authToken = ref(authStored.authToken);
      console.log(authToken)

      const fetchData = async () => {
        const id = props.selectedData.id;
        try {
          const apiUrl = `${process.env.VUE_APP_NEST_CAP_CONSULTAPASIVO}/${id}`;
          const response = await fetch(apiUrl, {
            method: 'GET',
            headers: {
              Authorization: `Bearer ${props.authToken}`,
            },
          });

          if (!response.ok) {
            throw new Error(`Error al obtener datos: ${response.statusText}`);
          }
          const data = await response.json();
          collectionData.value = [data];
          collectionData.value = data.map(cap => ({ ...cap, soporteCaps: [] }));
        } catch (error) {
          console.error(error);
        }
      };


      const openSoporte = async (url) => {
        const res = await useAPIRest(process.env.VUE_APP_NEST_SOPORTE_CAP_OBTENERARCHIVO + '?url=' + url, 
                        'GET', props.authToken)
        if(res.status === 200) {
          const blob = await res.blob()
          const filename = url.substring(url.lastIndexOf('/') + 1);
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = filename || 'downloaded_file';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }else{
          swal.fire('¡No se cargó un soporte de este CAP!', '', 'error');
        }             
      }   

      fetchData();
  
        return {
          collectionData,
          openSoporte,
          fetchData
        }; 
    },
    watch:{

    },
    methods:{

      handleBack() {
          this.$emit('updateValues', { 'view': 'listar' });
      },

      async fetchSoporteCap(id) {
        try {
          const apiUrl = `${process.env.VUE_APP_NEST_CAP_CONSULTACAP}/${id}`;
          const response = await fetch(apiUrl, {
            method: 'GET',
            headers: {
              Authorization: `Bearer ${this.authToken}`,
            },
          });

          if (!response.ok) {
            throw new Error(`Error al obtener datos del soporte_cap: ${response.statusText}`);
          }

          const dataSoporte= await response.json();
          const capIndex = collectionData.value.findIndex(cap => cap.id === id);
          if (capIndex !== -1) {
            collectionData.value[capIndex].soporteCaps = [dataSoporte];
          }
          this.openSoporte(dataSoporte.url_archivo);
        } catch (error) {
          console.error(error);
        }
      },

      async descargarSoporteCap(url){
        console.log(this.authToken)
        const res = await useAPIRest(process.env.VUE_APP_NEST_SOPORTE_ASOCIADO_CAP_OBTENERARCHIVO + '?url=' + url, 
                        'GET', this.authToken)
        const blob = await res.blob()
        const filename = url.substring(url.lastIndexOf('/') + 1);
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = filename || 'downloaded_file';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      },

      async consultarSoportesAsociados(id) {
        // console.log(id)
        try {
          const apiUrl = `${process.env.VUE_APP_NEST_CAP_ASOCIADO_CONSULTACAP}/${id}`;
          const response = await fetch(apiUrl, {
            method: 'GET',
            headers: {
              Authorization: `Bearer ${this.authToken}`,
            },
          });

          if (!response.ok) {
            throw new Error(`Error al obtener datos del soporte_asociado: ${response.statusText}`);
          }

          this.collectionDataSoportes= await response.json();
         
          if (this.collectionDataSoportes.length > 0) {
            swal.fire('¡Puede ver los soportes asociados en la parte inferior!', '', 'success');
            this.showSoportesTable = true;
            this.collectionDataSoportes;
          } else {
            swal.fire('¡Aun no hay soportes asociados al CAP!', '', 'error');
          }

        } catch (error) {
          console.error(error);
        }
      },

      async cambiarEstado(id) {
        const data = { id: id };
        try {
          const apiUrl1 = `${process.env.VUE_APP_NEST_CAP_UPDATESTATE}`;
          const listApi = { update: apiUrl1 };

          const resJSON = await saveUpdateData({
            selectedData: data,
            listApi,
            authToken: this.authToken,
            loadData: data,
            action: 'actualizar',
            entity: this.entity,
          }, false, false, false);

          if (resJSON.statusCode === 403){
            console.error("error");
          }

          window.location.reload();
          this.fetchData();

        } catch (error) {
          console.error(error);
        }
      },

      async confirmarCambioEstado(id) {
        const result = await swal.fire({
            title: '¿Está seguro de eliminar el soporte asociado?',
            html: "El soporte se eliminará de la plataforma <b>DEFINITIVAMENTE</b>",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Aceptar',
            cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
            this.cambiarEstadoSoporte(id);
        }
      },

      async cambiarEstadoSoporte(id) {
        const data = { id: id };
        try {
          const apiUrl1 = `${process.env.VUE_APP_NEST_SOPORTE_ASOCIADO_CAP_UPDATESTATE}`;
          const listApi = { update: apiUrl1 };

          const resJSON = await saveUpdateData({
            selectedData: data,
            listApi,
            authToken: this.authToken,
            loadData: data,
            action: 'actualizar',
            entity: this.entity,
          }, false, false, false);

          if (resJSON.statusCode === 403){
            console.error("Error");
          }

          this.showSoportesTable = false,
          this.fetchData();

        } catch (error) {
          console.error(error);
        }
      },
    }
  };
  
  const collectionData = ref([]);


</script>


<style scoped>
.custom-width-table {
  width: 600%;
}

.custom-width-table-soportes{
  width: 60%;
}
</style>
